import PrivateCoachingInquiryListForCoach
    from "@/views/App/Unemployed/Coaching/PrivateCoaching/InquiryOverview/InquiryForCoachList.vue";
import PrivateCoachingInquiryDetails
    from "@/views/App/Unemployed/Coaching/PrivateCoaching/InquiryOverview/InquiryDetails.vue";

const routesUnemployedInquiryOverview = [
    {
        path: 'private-coaching/inquiry-list-for-coach',
        name: 'privateCoachingInquiryOverviewListForCoach',
        component: PrivateCoachingInquiryListForCoach
    },
    {
        path: 'private-coaching/inquiry-details/:id',
        name: 'privateCoachingInquiryDetails',
        component: PrivateCoachingInquiryDetails
    },

];

export default routesUnemployedInquiryOverview;